//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import { mdiHomeOutline, mdiBellOutline, mdiAccountOutline, mdiMessageOutline, mdiCloudOutline, mdiAlertOutline } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiBellOutline,
        mdiAccountOutline,
        mdiMessageOutline,
        mdiCloudOutline,
        mdiAlertOutline,
      },
    }
  },
}
